module.exports = __webpack_public_path__ + "static/media/routes08.538fc7bd.webp";